import {
  PPROJECT_DOCUMENTS_DELETE_SUCCESS,
  ADD_NEW_PROJECT_NOTE_SUCCESS,
  ADD_NEW_PROJECT_NOTE_ATTEMPT,
  ADD_RELATED_IDEA_ATTEMPT,
  ADD_RELATED_IDEA_SUCCESS,
  DELETE_RELATED_THEME_SUCCESS,
  DELETE_RELATED_THEME_ATTEMPT,
  GET_RELATED_SOLUTIONS_SUCCESS,
  DELETE_RELATED_SOLUTION_SUCCESS,
  ADD_RELATED_SOLUTION_SUCCESS,
} from "./overview.action";

const initState = {
  documents: [],
  loading: false,
  shouldUpdateRelatedIdeas: false,
  shouldUpdateRelatedThemes: false,
  projectSolutions: [],
};

const overviewReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NEW_PROJECT_NOTE_ATTEMPT: {
      return {
        ...state,
        loading: true,
      };
    }
    case ADD_NEW_PROJECT_NOTE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case ADD_RELATED_IDEA_ATTEMPT: {
      return {
        ...state,
        shouldUpdateProjects: false,
        loading: true,
      };
    }
    case ADD_RELATED_IDEA_SUCCESS: {
      return {
        ...state,
        shouldUpdateProjects: true,
        loading: false,
      };
    }
    case DELETE_RELATED_THEME_ATTEMPT: {
      return {
        ...state,
        loading: true,
      };
    }
    case DELETE_RELATED_THEME_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case GET_RELATED_SOLUTIONS_SUCCESS: {
      return {
        ...state,
        projectSolutions: payload.response,
      };
    }
    case DELETE_RELATED_SOLUTION_SUCCESS: {
      return {
        ...state,
        projectSolutions: [
          ...state.projectSolutions.filter((sol) => {
            if (sol.id === payload) {
              return false;
            }
            return true;
          }),
        ],
      };
    }
    case ADD_RELATED_SOLUTION_SUCCESS: {
      return {
        ...state,
        projectSolutions: [...payload.response, ...state.projectSolutions],
      };
    }

    case PPROJECT_DOCUMENTS_DELETE_SUCCESS:
      break;
    default:
      return { ...state };
  }
  return state;
};

export default overviewReducer;
